import {
  CloseOrderPreparation,
  OrderPreparationRecord,
  OrderPreparationRecordStatRefactor,
  SearchOrderPreparationRecords,
} from "../dtos";
import { BaseEndpoint } from "./BaseEndpoint";

export class Endpoint extends BaseEndpoint("order-preparations") {
  findRecords(query: SearchOrderPreparationRecords): Promise<OrderPreparationRecord[]> {
    return this.request("records", { method: "POST", body: { query } });
  }

  getRecordsStat(
    productIds: string[],
    options?: { signal?: AbortSignal },
  ): Promise<OrderPreparationRecordStatRefactor[]> {
    return this.request("records-stat", { method: "POST", body: { productIds }, signal: options?.signal });
  }

  close(body: CloseOrderPreparation): Promise<void> {
    return this.request("", { method: "POST", body });
  }
}

export const OrderPreparationEndpoint = Endpoint;
